import { CertificationCategory } from '@/utils/Enumerations'

export default {
  allCertifications: (state) => state.certifications,
  accountCertifications: (state) => state.certifications.filter(c => c.category === CertificationCategory.Account.value)
}
